<template>
  <div>
    <div class="background-image"></div>
    <div class="container-xxl">
      <!--
        The shell renders immediately; no route waits for bulk match history.
        The weekly bar is hidden by CSS on small screens, so it is also not
        mounted there: its subscriptions and weekly passes would otherwise
        still run on phones for a panel nobody can see.
      -->
      <div v-if="showTopStatsBar" class="top-panel-shell"><TopStatsBar /></div>
      <navbar>
        <template #Home>
          <router-link class="nav-link" to="/">Home</router-link>
        </template>

        <template #Matches>
          <router-link class="nav-link" to="/matches">Matches</router-link>
        </template>

        <template #Heros>
          <router-link class="nav-link" :to="{ name: 'Heros', query: persistentViewQuery }">Heros</router-link>
        </template>

        <template #Items>
          <router-link class="nav-link" :to="{ name: 'Items', query: persistentViewQuery }">Items</router-link>
        </template>

        <template #Leaderboard>
          <router-link class="nav-link" to="/leaderboard">Leaderboard</router-link>
        </template>
      </navbar>
      <router-view></router-view>
    </div>
  </div>
  <!-- <footer2></footer2> -->
</template>

<script>
import navbar from './components/navbar.vue'
// import footer2 from './components/footer.vue';
import TopStatsBar from './components/top_stats_bar.vue'
import { buildViewFiltersQuery, getViewFilters } from './service/viewfilters.js'

import 'bootstrap/dist/css/bootstrap.min.css'
import 'jquery/src/jquery.js'
import 'bootstrap/dist/js/bootstrap.min.js'

// Must match the `.top-panel-shell { display: none }` breakpoint below.
const TOP_BAR_HIDDEN_QUERY = '(max-width: 768px)'

export default {
  name: 'App',
  components: {
    navbar,
    TopStatsBar,
    // footer2
  },
  data() {
    return {
      showTopStatsBar: false,
    }
  },

  computed: {
    persistentViewQuery() {
      return buildViewFiltersQuery(getViewFilters(this.$route))
    },
  },

  created() {
    this.topBarMedia = null
    this.onTopBarMediaChange = null

    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
      this.showTopStatsBar = true
      return
    }

    this.topBarMedia = window.matchMedia(TOP_BAR_HIDDEN_QUERY)
    this.showTopStatsBar = !this.topBarMedia.matches
    this.onTopBarMediaChange = (event) => {
      this.showTopStatsBar = !event.matches
    }

    if (typeof this.topBarMedia.addEventListener === 'function') {
      this.topBarMedia.addEventListener('change', this.onTopBarMediaChange)
    } else if (typeof this.topBarMedia.addListener === 'function') {
      this.topBarMedia.addListener(this.onTopBarMediaChange)
    }
  },

  beforeUnmount() {
    const media = this.topBarMedia
    const handler = this.onTopBarMediaChange
    if (!media || !handler) return
    if (typeof media.removeEventListener === 'function') {
      media.removeEventListener('change', handler)
    } else if (typeof media.removeListener === 'function') {
      media.removeListener(handler)
    }
    this.topBarMedia = null
    this.onTopBarMediaChange = null
  },
}
</script>

<style>
/* Variables for primary and secondary */

:root {
  --primary-color: hsl(192deg, 89%, 9%);
  --secondary-color: hsl(192deg, 89%, 11%);
  --primary-border-color: rgb(38, 70, 83);
  --kop-surface: rgba(9, 18, 24, 0.62);
  --kop-surface-strong: rgba(13, 31, 38, 0.96);
  --kop-surface-soft: rgba(7, 15, 20, 0.48);
  --kop-border: rgba(91, 141, 155, 0.26);
  --kop-border-strong: rgba(130, 174, 184, 0.42);
  --kop-accent: #ffbf66;
  --kop-green: #62d690;
  --kop-blue-team: rgba(73, 111, 210, 0.36);
  --kop-red-team: rgba(210, 80, 75, 0.34);
}
@media (min-width: 1400px) {
  .container-xxl {
    max-width: 1500px !important;
  }
}

.bg-primary {
  border: 1px solid var(--primary-border-color);
  background-color: var(--primary-color) !important;
}

.bg-secondary {
  background-color: var(--secondary-color) !important;
}

@font-face {
  src: url('./assets/fonts/pixel.ttf');
  font-family: 'Glasstown NBP';
}

.background-image {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
  background-image: url('./assets/background.png');
  background-size: cover;
  filter: hue-rotate(40deg) brightness(25%);
  /* Add backlight effect */
}

.top-panel-shell {
  margin-bottom: 1rem;
}

.router-link-active {
  color: var(--kop-accent) !important;
}

a {
  color: #d9d9d9 !important;
  text-decoration: none !important;
}

a:hover {
  color: white !important;
  filter: brightness(0.9);
}

p,
span {
  color: #d9d9d9 !important;
}

.kop-page {
  animation: kop-page-in 0.24s ease-out;
}

.kop-panel {
  border: 1px solid var(--kop-border);
  border-radius: 8px;
  background: var(--kop-surface);
  box-shadow: 0 16px 42px rgba(0, 0, 0, 0.22);
}

.kop-filter-panel {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 20px;
  padding: 10px;
  border-radius: 8px;
  border: 1px solid rgba(91, 141, 155, 0.18);
  background: var(--kop-surface-soft);
}

.kop-toggle {
  color: white;
  display: flex;
  align-items: center;
  gap: 6px;
  min-height: 38px;
  margin: 0;
  padding: 0 12px;
  border-radius: 8px;
  border: 1px solid rgba(130, 174, 184, 0.3);
  background: rgba(14, 31, 38, 0.78);
  cursor: pointer;
  transition: background 0.18s ease, border-color 0.18s ease, transform 0.18s ease;
}

.kop-toggle:hover {
  border-color: rgba(255, 191, 102, 0.62);
  transform: translateY(-1px);
}

.kop-toggle input {
  accent-color: var(--kop-accent);
}

.kop-button {
  min-height: 38px;
  border: 1px solid rgba(255, 191, 102, 0.4) !important;
  border-radius: 8px !important;
  background: rgba(33, 61, 66, 0.96) !important;
  color: white !important;
  transition: background 0.18s ease, border-color 0.18s ease, transform 0.18s ease;
}

.kop-button:hover {
  background: rgba(48, 78, 82, 0.98) !important;
  border-color: rgba(255, 191, 102, 0.72) !important;
  transform: translateY(-1px);
}

.kop-input,
.kop-select {
  min-height: 38px;
  border: 1px solid var(--kop-border-strong) !important;
  border-radius: 8px !important;
  background-color: rgba(10, 20, 27, 0.92) !important;
  color: white !important;
  transition: border-color 0.18s ease, box-shadow 0.18s ease;
}

.kop-input:focus,
.kop-select:focus {
  border-color: var(--kop-accent) !important;
  box-shadow: 0 0 0 0.18rem rgba(255, 191, 102, 0.16) !important;
}

@keyframes kop-page-in {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* width */
::-webkit-scrollbar {
  width: 10px;
}

/* Track */
::-webkit-scrollbar-track {
  background: var(--primary-color);
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: var(--secondary-color);
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: rgb(3, 31, 43);
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
  margin-top: 24px;
}

.blue-team-text {
  color: rgba(100, 100, 255, 0.7);
}

.red-team-text {
  color: rgba(255, 100, 100, 0.7);
}

.bronze-medal {
  color: #ffda70 !important;
}
.silver-medal {
  color: #cce2e1 !important;
}
.gold-medal {
  color: gold !important;
}
.platinum-medal {
  color: #8cffdd !important;
}
.diamond-medal {
  color: #78d9ff !important;
}
.mythical-medal {
  color: #ff4e00 !important;
}

td {
  padding: 0.3rem 0.3rem !important;
}

@media (max-width: 768px) {
  .container-xxl {
    margin-bottom: 12px;
    padding: 0 0.5rem;
  }

  .top-panel-shell {
    display: none;
  }

  #app {
    margin-top: 5px;
  }

  input[type='checkbox'] {
    width: 16px;
    height: 16px;
  }
}
</style>
